export interface GkFaq {
  question: string;
  answer: string;
  group: string;
}

export const gkFaqs: GkFaq[] = [
  {
    group: "关于瓜料",
    question: "看吃瓜每天什么时候更新今日新瓜？",
    answer: "我们坚持『每日瓜料准时更新』。工作日通常从清晨开始分早、午、晚三批推送最新爆料与新鲜瓜速递，周末与热点密集期还会加更，确保不让你错过任何一场热闹。",
  },
  {
    group: "关于瓜料",
    question: "这里的瓜料信息可靠吗？会不会是编造？",
    answer: "我们以娱乐资讯与公开讨论汇总为主，会明确标注信息来源与推测成分，并尽量附上可回溯的事件脉络。遇到尚在发酵的传闻，我们会用『网传』等字眼提醒读者，做到吃瓜不吃假。",
  },
  {
    group: "关于栏目",
    question: "你们有哪几类栏目？",
    answer: "目前设有明星动态、综艺现场、影视热播、音乐现场、社交热榜五类栏目，分别覆盖艺人新动态、节目名场面、剧集收视、歌曲发布与全网热门话题，方便你按兴趣快速定位今日想吃的新瓜。",
  },
  {
    group: "关于栏目",
    question: "我想找某条今天的热点，应该怎么搜？",
    answer: "你可以在栏目页使用搜索框输入关键词，或直接点击首页的热门话题标签进行筛选。首页也设有『今日热点』板块，方便你快速扫一眼当天最值得关注的瓜料。",
  },
  {
    group: "关于投稿",
    question: "我发现了有意思的瓜，可以投稿吗？",
    answer: "当然可以！我们欢迎瓜友提供线索。你可以在『关于我们』页找到投稿邮箱，或在文章页通过分享入口反馈。投稿经核实整理后会以栏目文章的形式发布，并会注明信息提供来源。",
  },
  {
    group: "关于权益",
    question: "转载或引用看吃瓜的内容需要注意什么？",
    answer: "欢迎在注明出处的情况下转载观点类内容。但涉及他人肖像、著作权与名誉权的图文，请勿擅自商用或恶意剪辑，以免引发版权与名誉纠纷，这也是我们一直倡导理性吃瓜的原因。",
  },
];